import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react-dom';

export default function usePopper(reference, floating, options = {}) {
  const gap = options.modifiers?.find(item => item.name === 'offset')?.options?.offset?.[1] || 0;
  const result = useFloating({
    elements: { reference, floating },
    placement: options.placement || 'bottom-start',
    strategy: options.strategy || 'absolute',
    middleware: [offset(gap), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });
  return { styles: { popper: result.floatingStyles }, attributes: { popper: { 'data-popper-placement': result.placement } }, update: result.update, forceUpdate: result.update };
}
